module.exports = __webpack_public_path__ + "img/shang-palace_0.479704eb.jpg";